import React from "react";
import { selectFormat } from "../Utils.js";
import { XRayTooltipHeader } from "./../XrayUtils.js";

export const XRayDonationsBarLineChart = (props) => {
  const { data, close } = props;

  return (
    <div>
      <XRayTooltipHeader date={data.activeLabel} close={close} />
      <main className="standard-tooltip__main">
        {Object.keys(data.activePayload)
          .sort(
            (a, b) => data.activePayload[b].value - data.activePayload[a].value
          )
          .filter((key) => data.activePayload[key].value > 0)
          .map((key, index) => {
            return (
              <div className="standard-tooltip__item" key={key}>
                <span
                  className="standard-tooltip__icon"
                  // set the backgroun color according the chart name
                  style={{
                    background: data.activePayload[key].color,
                  }}
                />

                {data.activePayload[key].name === "visits"
                  ? "Emails"
                  : "New Donations"}

                <span className="standard-tooltip__value">
                  {selectFormat("number", data.activePayload[key].value)}
                </span>
              </div>
            );
          })}
      </main>
    </div>
  );
};
